import { css } from 'styled-components';
export * from './common.css';

export const section = css`
  padding: 72px 0;
`;

export const sectionHeading = css`
  margin: 0;
  margin-top: var(--mt);
  font-size: var(--fz);
  text-align: center;
  --fz: 24px;
  @media (min-width: 24em) {
    --fz: 30px;
  }
  @media (min-width: 36em) {
    --fz: 36px;
  }
`;

export const grid = css`
  margin-top: 50px;
  display: grid;
  grid-gap: 2rem;
  grid-auto-rows: max-content;
  grid-auto-flow: row dense;
  @media (min-width: 40em) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (min-width: 60em) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
`;

export const cell = css`
  color: inherit;
  text-decoration: none;
  box-shadow: 0 9px 22px 0 rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border-radius: 1rem;
  overflow: hidden;
  background-color: white;
  &:hover,
  &:active {
    text-decoration: none;
    box-shadow: 0 14px 28px 0 rgba(0, 0, 0, 0.1);
    transform: translateY(-0.25rem);
    .cta,
    .heading {
      text-decoration: underline;
    }
  }
  grid-column: var(--col);
  grid-row: var(--row);
  --dir: column;
  --col: span 1;
  --row: span 1;
`;

export const cell1 = css`
  @media (min-width: 60em) {
    --col: span 2;
    --row: span 2;
  }
`;

export const cell2 = css`
  @media (min-width: 60em) {
    --col: span 3;
    --dir: row;
    & * .card-header {
      flex: 0 0 auto;
      width: 40%;
      min-width: 0;
    }
  }
`;

export const cell3 = css`
  @media (min-width: 40em) {
    --col: span 2;
    --dir: row;
    & * .card-header {
      flex: 0 0 auto;
      width: 40%;
    }
  }

  @media (min-width: 60em) {
    --col: span 3;
    & * .card-header {
      flex: 0 0 auto;
      width: 40%;
    }
  }
`;

export const article = css`
  display: flex;
  flex-direction: var(--dir);
  min-height: 100%;
  font-size: 1rem;
  --alternative-heading-color: initial;
`;

export const cardArticle = css``;

export const cardImage = css`
  width: 100%;
  min-height: 100%;
`;

export const cardMain = css`
  display: flex;
  flex-direction: column;
  align-items: start;
  flex: 1 1 auto;
  padding: 20px;
  --mt: 20px;
`;

export const heading = css`
  margin: 0;
  margin-top: var(--mt);
  margin-bottom: 2rem;
  font-size: var(--fz);
  --fz: 24px;
`;

export const content = css`
  margin: 0;
  margin-top: var(--mt);
  font-size: var(--fz);
  --fz: 16px;
`;

export const cta = css`
  margin: 0;
  margin-top: auto;
  font-weight: 500;
  font-size: var(--fz);
  --fz: 18px;
  color: #5a16ee;
`;
